module.exports = __webpack_public_path__ + "static/media/articles1.17abe502.jfif";